import { useMemo, useState } from "react";
import { CreatorByIdPlatform } from "./CreatorByIdPlatform.tsx";
import { platformOrders } from "../data.ts";
import { faEnvelope } from "@fortawesome/pro-solid-svg-icons";
import { useFlags } from "launchdarkly-react-client-sdk";
import { RevLink, RevTabs } from "@revmatics/catalyst";
import { HideCreatorMenu } from "./creatorCard/HideCreatorMenu.tsx";
import { LikeButton } from "./creatorCard/LikeButton.tsx";
import { useAppSelector } from "../../../../../../../stores/hooks/hooks.ts";

type Props = {
  menu?: boolean;
};

export const CreatorOverviewSlideOut = ({ menu }: Props) => {
  const { hideCreator: ffHideCreator, likeCreator: ffLikeCreator } = useFlags();
  const creatorById = useAppSelector((state) => state.creators.creatorById);

  const sortingTabsData = useMemo(
    () =>
      creatorById?.platforms
        .slice()
        .sort(
          (a, b) =>
            (platformOrders[a.platform.name.toLowerCase()] ?? Infinity) -
            (platformOrders[b.platform.name.toLowerCase()] ?? Infinity),
        )
        .map(({ platform }) => ({
          id: platform.name.toLowerCase(),
          title: platform.name,
        })),
    [creatorById],
  );
  const [activeTab, setActiveTab] = useState(
    sortingTabsData && sortingTabsData.length > 0
      ? sortingTabsData[0].id
      : undefined,
  );

  const activePlatformData = useMemo(() => {
    return creatorById?.platforms.find(
      (p) => p.platform.name.toLowerCase() === activeTab,
    );
  }, [activeTab, creatorById]);

  const contactInfo = useMemo(() => {
    return (
      creatorById?.platforms.find((p) => p.contact_info)?.contact_info || false
    );
  }, [creatorById]);

  if (creatorById) {
    return (
      <div className="p-4 bg-primary-25 flex flex-col gap-4 flex-1">
        <RevTabs
          data={sortingTabsData || []}
          selected={activeTab}
          handleSelect={(id: string) => setActiveTab(id)}
          tabId={`creator-${creatorById.id}-platforms`}
        />
        {activePlatformData && (
          <CreatorByIdPlatform data={activePlatformData} />
        )}
        {menu && (
          <div
            className={`grid grid-cols-1 md:grid-cols-2 gap-3 w-full
      ${[ffHideCreator, contactInfo, ffLikeCreator].includes(false) ? "grid-cols-1 md:grid-cols-2" : "grid-cols-1 md:grid-cols-3"}`}
          >
            {contactInfo ? (
              <RevLink
                text="Contact Creator"
                iconLeft={faEnvelope}
                displayAs="button"
                buttonVariant="secondary"
                buttonSize="extraSmall"
                local={false}
                pathname={`mailto:${contactInfo}`}
                target="_self"
              />
            ) : ffLikeCreator && ffHideCreator ? null : (
              <div />
            )}
            {ffHideCreator && (
              <HideCreatorMenu
                id="overview"
                creatorId={creatorById.id}
                initHidden={creatorById.user_interaction_status === "hidden"}
                width="w-full"
              />
            )}
            <LikeButton
              creatorId={creatorById.id}
              initLiked={creatorById.user_interaction_status === "liked"}
            />
          </div>
        )}
      </div>
    );
  }

  return null;
};
